import { useColorModeValue } from "@chakra-ui/react";
import { useTheme } from "next-themes";

/** Resolved hex for lightweight-charts (CSS vars are not reliable on canvas). */
export const TRADE_REVIEW_CHART_BG_LIGHT = "#ffffff";
export const TRADE_REVIEW_CHART_BG_DARK = "#151517";

export function useTradeReviewThemeColors(visualStyle: "default" | "reports" = "default") {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const isReportsEmbed = visualStyle === "reports";

  const defaultCardBg = useColorModeValue("white", TRADE_REVIEW_CHART_BG_DARK);
  const defaultBorderColor = useColorModeValue("gray.200", "gray.600");
  const defaultSecondaryTextColor = useColorModeValue("gray.400", "white");
  const defaultInputBg = useColorModeValue("white", TRADE_REVIEW_CHART_BG_DARK);
  const defaultChipBg = useColorModeValue("cyan.50", "whiteAlpha.100");
  const defaultChartGridColor = useColorModeValue("#e7e7e7", "#2D3748");
  const defaultChartTextColor = useColorModeValue("#575757", "#c8cfca");
  const defaultChartLabelBg = useColorModeValue("rgba(255,255,255,0.85)", "rgba(21,21,23,0.85)");
  const defaultChartNavBtnBg = useColorModeValue("white", "#1e1e20");
  const defaultChartNavBtnBorder = useColorModeValue("gray.200", "gray.600");
  const defaultTableTextColor = useColorModeValue("#575757", "white");
  const defaultTableSecondaryTextColor = useColorModeValue("gray.400", "white");
  const defaultTableTheadBg = useColorModeValue("gray.50", "gray.800");

  if (!isReportsEmbed) {
    return {
      isDark,
      isReportsEmbed,
      cardBg: defaultCardBg,
      borderColor: defaultBorderColor,
      secondaryTextColor: defaultSecondaryTextColor,
      inputBg: defaultInputBg,
      chipBg: defaultChipBg,
      chartBg: defaultCardBg,
      chartGridColor: defaultChartGridColor,
      chartTextColor: defaultChartTextColor,
      chartLabelBg: defaultChartLabelBg,
      chartNavBtnBg: defaultChartNavBtnBg,
      chartNavBtnBorder: defaultChartNavBtnBorder,
      tableTextColor: defaultTableTextColor,
      tableSecondaryTextColor: defaultTableSecondaryTextColor,
      tableTheadBg: defaultTableTheadBg,
    };
  }

  return {
    isDark,
    isReportsEmbed,
    cardBg: undefined as string | undefined,
    borderColor: isDark ? "var(--border)" : "gray.200",
    secondaryTextColor: isDark ? "#ffffff" : "gray.500",
    inputBg: isDark ? TRADE_REVIEW_CHART_BG_DARK : "white",
    chipBg: isDark ? "whiteAlpha.100" : "cyan.50",
    chartBg: isDark ? TRADE_REVIEW_CHART_BG_DARK : TRADE_REVIEW_CHART_BG_LIGHT,
    chartGridColor: isDark ? "#2D3748" : "#e7e7e7",
    chartTextColor: isDark ? "#c8cfca" : "#575757",
    chartLabelBg: isDark ? "rgba(21,21,23,0.85)" : "rgba(255,255,255,0.85)",
    chartNavBtnBg: isDark ? "#1e1e20" : "#ffffff",
    chartNavBtnBorder: isDark ? "gray.600" : "gray.200",
    tableTextColor: isDark ? "#ffffff" : "#575757",
    tableSecondaryTextColor: isDark ? "#ffffff" : "gray.500",
    tableTheadBg: isDark ? TRADE_REVIEW_CHART_BG_DARK : "white",
  };
}
